import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rotas } from 'src/app/core/rotas';
import { TipoReuniao } from '../../core/tipo-reuniao';
import { BaseService } from '../base/base.service';


@Injectable({
  providedIn: 'root'
})
export class TiposReuniaoService extends BaseService<TipoReuniao> {

  getTipoReuniaoById(id: number) {
    return this.http.get(`${Rotas.TIPOS_REUNIOES}${id}`);
  }
  
  constructor(http: HttpClient) {
    super(http, Rotas.TIPOS_REUNIOES);
  }

  getAllCombo() {
    return this.http.get(`${Rotas.TIPOS_REUNIOES}combo`);
  }

}

